<template>
  <div v-if="$i18n.locale() === 'es'" class="container is-uppercase h-max is-size-7">
    <router-link :to="{ name: 'Home' }" style="background: #131313;width: 100%;display: block;">
      <img src="@/../static/es-orange/images/header.jpg" class="image" />
    </router-link>
    <h1 class="is-size-6 has-text-centered">SUBSCRIPCIÓN COMPLETADA</h1>
    <div class="p-md has-text-centered">
      Gracias por utilizar nuestro servicio. Esta suscripción tiene un coste de 2.99€ semana (i.i.i), renovación automática. Si deseas cancelarla, haz click <router-link class="has-text-grey-dark  has-text-weight-bold" :to="{ name: 'Deactivation' }">AQUI</router-link>
    </div>
    <div class="has-text-centered">
      <img src="@/../static/es-orange/images/image.jpg" class="image is-inline-block" style="width: 70%;" />
    </div>
    <div class="has-text-centered w-max m-t-md m-b-md">
      <router-link :to="{ name: 'CreateProfile' }" class="button p-t-sm p-b-sm p-l-lg p-r-lg has-background-primary has-text-white">Comenzar a entrenar</router-link>
    </div>
    <p class="has-text-centered">
      Si no accedes al contenido automáticamente en unos segundos, por favor, pulsa el botón. Atención al cliente: 900 373 556 es.cuca@778mobile.com
    </p>
    <Footer class="fixed-bl fixed-br" />
  </div>
  <div v-else class="container is-uppercase has-text-weight-bold h-max">
    <Header />
    <div class="p-md">
      {{ $t('The transaction was successful. Thank you for using the service.') }} <br>
      {{ $t('You will be redirected to the site in a moment. If this does not happen in a few seconds, click Next.') }}
    </div>
    <div class="has-text-centered w-max m-t-md">
      <router-link :to="{ name: 'CreateProfile' }" class="button p-t-sm p-b-sm p-l-lg p-r-lg has-background-primary has-text-white">{{ $t('Next') }}</router-link>
    </div>
    <Footer class="fixed-bl fixed-br" />
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'PaymentConfirm',
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }

    const redirect = (() => this.$router.push({ name: 'CreateProfile' })).bind(this)
    setTimeout(redirect, 5000)
  },
  components: {
    Header,
    Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/PaymentConfirm.vue